// extracted by mini-css-extract-plugin
export default {"container":"AttachmentFile_container__IQbMY","info":"AttachmentFile_info__kCVR4","header":"AttachmentFile_header__zMHdD"};